// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const operatorAnnouncementId = (z.number());
export const operatorAnnouncement = z.object({
    id: operatorAnnouncementId,
    operator_id: operatorId,
    announcement_id: z.string(),
    shown_at: z.date(),
});
export const operatorAnnouncementInitializer = z.object({
    id: operatorAnnouncementId.optional(),
    operator_id: operatorId,
    announcement_id: z.string(),
    shown_at: z.date().optional(),
});
export const operatorAnnouncementMutator = z.object({
    id: operatorAnnouncementId.optional(),
    operator_id: operatorId.optional(),
    announcement_id: z.string().optional(),
    shown_at: z.date().optional(),
});
//# sourceMappingURL=OperatorAnnouncement.js.map